/**
 * Les chemins des écrans de régie.
 *
 * Exportés ici plutôt qu’ajoutés à `lib/chemins.ts`, pour la même raison que
 * `CHEMIN_APPARENCE` : ce fichier-là appartient à la fondation et plusieurs
 * chantiers y écrivent en même temps. Une constante de plus dans un fichier
 * partagé, c’est un conflit de fusion pour une valeur qui n’intéresse que ce
 * module.
 *
 * `/admin/regie` et non `/admin/deblocage` : c’est le mot du métier — la régie
 * est l’endroit d’où l’on reprend la main quand la salle ne se comporte pas
 * comme prévu.
 */

export const CHEMIN_REGIE = '/admin/regie'
export const CHEMIN_DIAGNOSTIC = `${CHEMIN_REGIE}/sieges`
export const CHEMIN_ABONNEMENTS = `${CHEMIN_REGIE}/abonnements`
export const CHEMIN_PANIERS_REGIE = `${CHEMIN_REGIE}/paniers`
export const CHEMIN_PHASES = `${CHEMIN_REGIE}/phases`
export const CHEMIN_ESPACE_ABONNE = `${CHEMIN_REGIE}/abonne`
export const CHEMIN_INTERVENTIONS = `${CHEMIN_REGIE}/demandes`
